import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';

export class AmazonS3Wrapper extends DatabaseWrapper {

    constructor(database: Database) {
        super(database);

        this.dbTyp_Id = DatabaseEnum.amazons3.ID;
        this.name = DatabaseEnum.amazons3.NAME;
        this.code = DatabaseEnum.amazons3.CODE;
        this.showDatabaseTab = false;
        this.showDataDescription =  false;
        this.equivalentTag = 'azid';
    }

    validateRepConn(repConnWrapper: RepConnWrapper): void {
        if (repConnWrapper.repConn.conn.amazonS3Host == '') {
            repConnWrapper.inValid_Cds.push('AMAZON_S3_HOST');
        }

        if (repConnWrapper.repConn.conn.bucketNm == '') {
            repConnWrapper.inValid_Cds.push('BUCKET_NM');
        }

        if (repConnWrapper.repConn.conn.accessToken == '') {
            repConnWrapper.inValid_Cds.push('ACCESS_KEY');
        }

        if (repConnWrapper.repConn.conn.accessTokenSecret == '') {
            repConnWrapper.inValid_Cds.push('SECRET_KEY');
        }

        if (repConnWrapper.repConn.conn.flagent_Id == -1) {
            repConnWrapper.inValid_Cds.push('ESM00202');
        }
    }
}
